import React from "react";
import { TableHead } from "../helper";

import ChallanActionRow from "./ChallanActionRow";
import ChallanHeaderRow from "./ChallanHeaderRow";

export default function ChallanTableHead({ columnConfig, ...rest }) {
  return (
    <TableHead>
      <ChallanActionRow {...rest} />
      <ChallanHeaderRow columnConfig={columnConfig} />
    </TableHead>
  );
}
